import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import POS from "@/pages/POS";
import MerchantDashboard from "@/pages/MerchantDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Storefront from "@/pages/Storefront";
import MobileUpload from "@/pages/MobileUpload";
import "@/App.css";

function Protected({ roles, children }) {
  const { user, ready } = useAuth();
  if (user === undefined) return <div className="pos-dark min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "cashier" ? "/pos" : (user.role.includes("admin") && user.role.includes("super")) || user.role === "support_admin" || user.role === "super_admin" ? "/admin" : "/merchant";
    return <Navigate to={home} replace />;
  }
  return children;
}

function Root() {
  const { user } = useAuth();
  if (user === undefined) return <div className="pos-dark min-h-screen" />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "super_admin" || user.role === "support_admin") return <Navigate to="/admin" replace />;
  if (user.role === "cashier") return <Navigate to="/pos" replace />;
  return <Navigate to="/merchant" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/store" element={<Storefront />} />
          <Route path="/mobile-upload/:token" element={<MobileUpload />} />
          <Route path="/pos" element={<Protected roles={["cashier", "merchant_owner", "store_manager", "inventory_clerk"]}><POS /></Protected>} />
          <Route path="/merchant" element={<Protected roles={["merchant_owner", "store_manager", "inventory_clerk"]}><MerchantDashboard /></Protected>} />
          <Route path="/admin" element={<Protected roles={["super_admin", "support_admin"]}><AdminDashboard /></Protected>} />
          <Route path="/" element={<Root />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
